import React from 'react';
import { t } from '../../../locales/i18n';
import { Button } from 'semantic-ui-react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function SubmitButton(props: any) {
  return <Button disabled={props.disabled} type="submit" primary content={props.isNew ? t('Create') : t('Update')} />;
}
